<!-- 门店管理-会员管理-积分结算 -->

<template>
  <div class="store-points-settle main-cnt">
    <div class="title">积分列表</div>
    <div class="content">
      <common-table ref="tableRef" tableHeight="calc(100vh - 320px)" :ischeck="false" :filters="filters"
        :ispaging="true" :apiName="StoreApi.getIntegralSettlement" :columns="tableColumns" @onDetailsBtn="onDetailsBtn"
        @projectChange="projectChange">
        <template #operate>
          <el-button type="primary" @click="handleExport" style="width: 120px;max-height: 40px;margin-bottom: 0;"
            v-if="authData.indexOf('n_34caf10f7d531fa6ab1744342') != -1">
            导出EXCEL
          </el-button>
        </template>

        <template #points_type="{ row }">
          <div class="flex align-center">
            <div v-if="row.integral_type_label" class="dots" :class="row.integral_type_label == '赠送' ? 'bg-blue' : 'bg-red'"></div>
            <div>{{ row.integral_type_label }}</div>
          </div>
        </template>
      </common-table>
    </div>

    <!-- 使用详情 -->
    <SettlementDetails ref="refDetails" @closeLoading="closeLoading"></SettlementDetails>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, } from "vue";
import { BasicApi, StoreApi, } from "@/plugins/api.js";
import { ElMessage, } from "element-plus";
import SettlementDetails from "../components/SettlementDetails.vue";
import { useStore } from "vuex";
import getBaseUrl from "@/plugins/baseUrl.js";
import encrypt from "../../../plugins/encrypt";

const baseUrl = getBaseUrl() ? getBaseUrl() : "";
// 权限
const store = useStore();
const menuTokens = computed(() => store.state.menuToken.menuTokens);
const authData = ref([]);
watch(
  () => menuTokens.value,
  (data) => {
    if (data.length) {
      authData.value = data;
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

onMounted(() => {
  getProjectData();
  tableRef.value.tableLoad();
});

const filters = ref([
  {
    filterType: "search",
    name: "keywords",
    value: "",
    placeholder: "请输入会员手机号",
  },
  {
    filterType: "select",
    name: "p_id",
    value: "",
    placeholder: "请选择项目",
    options: [],
    lab: "p_name",
    val: "p_id",
    action: "projectChange",
  },
  {
    filterType: "select",
    name: "source_id",
    value: "",
    placeholder: "请选择门店",
    options: [],
    lab: "pom_name",
    val: "pom_id",
  },
  {
    filterType: "select",
    name: "integral_type",
    value: "",
    placeholder: "请选择积分类型",
    options: [{ id: '1', name: '赠送' }, { id: '2', name: '消费' }],
    val: "id",
    lab: "name",
  },
  {
    filterType: "date",
    name: "stime",
    name2: "etime",
    value: [],
    placeholder: "请选择日期",
    type: "daterange",
  },
]);
/** 表格对象 */
const tableRef = ref(null);

/** 表格配置数据 */
const tableColumns = ref([
  {
    prop: "source_name",
    label: "资源名称",
  },
  {
    prop: "m_id",
    label: "会员ID",
  },
  {
    prop: "m_mobile",
    label: "会员手机",
  },
  {
    prop: "mi_integration",
    label: "积分",
  },
  {
    prop: "points_type",
    type: "customRender",
    label: "类型",
  },
  {
    prop: "created_at",
    label: "时间",
  },
  {
    type: "operation",
    prop: "",
    label: "操作",
    minWidth: 100,
    bottons: [
      {
        name: "详情",
        action: "onDetailsBtn",
        className: "theme-font-btn",
        token: "n_45548dafafaecdd23df6caca6",
      },
    ],
  },
]);

const refDetails = ref(null);  // 详情对话框对象
/**
 * 
 * 详情按钮
 * 
 * **/
const onDetailsBtn = (row) => {
  tableRef.value.isLoading = true;
  refDetails.value.openDialog(row.mi_id);
}
/**
 * 
 * 获取项目
 * 
 * **/
const getProjectData = () => {
  BasicApi.projectSelect().then((res) => {
    if (res.Code === 200) {
      filters.value[1].options = res.Data ? res.Data : [];
    } else {
      let msg = res.Message ? res.Message : "获取项目数据失败！";
      ElMessage.error(msg);
    }
  });
};
/**
 * 
 * 选择项目获取门店
 * 
 * **/
const projectChange = (obj) => {
  filters.value[2].value = "";
  filters.value[2].options = [];
  tableRef.value.tableLoad();
  if (obj.value) {
    BasicApi.getMerchantByProject({ pid: obj.value }).then((res) => {
      if (res.Code === 200) {
        filters.value[2].options = res.Data ? res.Data : [];
      } else {
        let msg = res.Message ? res.Message : "获取门店数据失败！";
        ElMessage.error(msg);
      }
    });
  }
};
/**
 * 
 * 导出
 * 
 * **/
function handleExport() {
  let reqData = {
    keywords: filters.value[0].value,
    p_id: filters.value[1].value,
    source_id: filters.value[2].value,
    integral_type: filters.value[3].value,
    stime: filters.value[4].value ? filters.value[4].value[0] : '',
    etime: filters.value[4].value ? filters.value[4].value[1] : '',
    limit: tableRef.value.limit,
    page: tableRef.value.currentPage,
  }
  const reqDataUrl =
    `keywords=${reqData.keywords}&p_id=${reqData.p_id}&source_id=${reqData.source_id}&integral_type=${reqData.integral_type}&stime=${reqData.stime}&etime=${reqData.etime}&limit=${reqData.limit}&page=${reqData.page}`;
  let data = encrypt.aesEncrypt(reqDataUrl);
  location.href = `${baseUrl}/polymerization/export/integration_settlement_list.api?${data}`;
}
/**
 * 
 * 关闭列表加载状态
 * 
 * **/
const closeLoading = () => {
  tableRef.value.isLoading = false;
}

</script>
<style lang="scss">
.store-points-settle {
  font-family: "Source Han Sans CN";

  .select-wp .select-right {
    padding: 0;
  }

  .content {
    padding: 15px 20px 20px;
  }
}
</style>